<template>
    <div class="page">
    </div>
</template>
<script>
    import { PAGE_ROOT } from 'page';
    export default {
        data() {
            return {

            }
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                var isSafari = vm.$util.isSafari();
                if (isSafari && vm.$route.query.schema) {
                    if (process.env.VUE_APP_MY_NODE == 'LOCAL') {
                        console.log('跳转页面', vm.$route.query.schema);
                    }
                    else {
                        window.location.href = vm.$route.query.schema;
                    }
                }
                else {
                    vm.$util.pageJump(PAGE_ROOT, vm.$route.query, null, {
                        jumpType: 1
                    })
                }
            });
        },
    }
</script>
